import {
  ProgressBar,
} from 'react-aria-components'
import {
  cva,
  type VariantProps,
} from 'class-variance-authority'

import { cn } from '@/shared/lib/cn'

const spinnerVariants = cva(
  'animate-spin',
  {
    variants: {
      size: {
        small: 'h-4 w-4',
        medium: 'h-6 w-6',
        large: 'h-10 w-10',
      },
    },

    defaultVariants: {
      size: 'medium',
    },
  },
)

export interface LoadingIndicatorProps
  extends VariantProps<
    typeof spinnerVariants
  > {
  label?: string
  showLabel?: boolean
  className?: string
}

export function LoadingIndicator({
  label = 'Loading',
  showLabel = false,
  size = 'medium',
  className,
}: LoadingIndicatorProps) {
  return (
    <ProgressBar
      isIndeterminate
      aria-label={label}
      className={cn(
        [
          'inline-flex items-center gap-3',
          'text-(--color-primary)',
        ],
        className,
      )}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        className={spinnerVariants({
          size,
        })}
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeWidth="3"
          className="opacity-25"
        />

        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          className="opacity-100"
        />
      </svg>

      {showLabel ? (
        <span className="text-sm font-medium text-(--color-muted-foreground)">
          {label}
        </span>
      ) : null}
    </ProgressBar>
  )
}